module.exports = __webpack_public_path__ + "img/bluetooth-signal.ed5e340d.svg";